import React, { Dispatch} from 'react';
import Translator from '../../../../../core/i18n';
import { Log } from 'ng2-logger';
import { Common } from '../../../../../core/common';
import { IAppState, IAction } from '../../../../../models/action/core';
import { connect } from 'react-redux';
import { IOpenEndedProps, IUserResponses } from '../../../../../models/components/activity-card-survey';
import { Notification } from '../../../../notification/main';

const T = Translator.create();
const _logger = Log.create('Survey Open Ended');
let _common: Common;

interface IResponseState {
    responseText: string;
    placeHolder: string;
}

class OpenEnded extends React.Component<IOpenEndedProps, IResponseState> {
    constructor(props: any) {
        super(props);
        _common = new Common();

    }

    state = {
        responseText: '',
        placeHolder: T.t("r_survey_write_answer")
    };

    setDefaultValues = () => {
        const userResponses = this.props.formik!.values.userResponses;
        let _selectedIds = this.state.responseText;
        userResponses.filter(r => r.surveyQuestionId === this.props.question.surveyQuestionId).forEach(element => {
            if (element.responseOpenEnded !== undefined) {
                _selectedIds = element.responseOpenEnded;
            }
        });
        this.setState({ responseText: _selectedIds });
    }

    componentDidMount() {
        this.setDefaultValues();
    }

    onWordLimit = (event: any) => {
        if (event.target.value.length > 4000) {
            Notification.setNotification('warning', T.t("r_survey_open_ended_character_limit_warning"), 'topRight')
        }
    }

    handleChange = (event: any) => {
        const userResponses = this.props.formik!.values.userResponses;
        let response: IUserResponses | undefined;
        let responseIndex = -1;

        responseIndex = userResponses.findIndex(
            (_response: IUserResponses) => _response.surveyQuestionId === this.props.question.surveyQuestionId
        );

        if (responseIndex !== -1) {
            response = userResponses.find((_response: IUserResponses) => _response.surveyQuestionId === this.props.question.surveyQuestionId);
        }

        this.setState({ responseText: event.target.value.length > 4000 ? event.target.value.substring(0, 4000) : event.target.value });

        if (response && responseIndex !== -1) {
            response.responseOpenEnded = event.target.value.length > 4000 ? event.target.value.substring(0, 4000) : event.target.value;
        } else {
            response = {
                surveyQuestionId: this.props.question.surveyQuestionId,
                responseOpenEnded: event.target.value.length > 4000 ? event.target.value.substring(0, 4000) : event.target.value,
                surveyQuestionChoiceId: ''
            };
            userResponses.push(response);
        }

        this.props.formik!.setFieldValue('userResponses', userResponses);
    }

    public render() {
        return (
            <div className="w-100 pr-3 card-q" key={this.props.key}>
                <div className="survey_question">

                    <input
                        type="text"
                        className={this.props.isCard ? 'survey_input' : 'survey_input'}
                        disabled={true}
                        value={this.props.question.description}
                        id="survey_question_input"
                        style={{ border: 'none', paddingLeft: '0px !important' }}
                    /> {this.props.isCard ? (
                        ''
                    ) : <hr className="bottom-border-2 mx-0" />}
                </div>
                <div className="row" style={this.props.isCard ? { padding: 15 } : { marginTop: '1em' }}>
                    <textarea
                        id="editing-input"
                        defaultValue={this.state.responseText}
                        placeholder={this.state.placeHolder}
                        className="survey_input"
                        rows={5}
                        style={{ height: '100px!important', }}
                        onChange={this.onWordLimit}
                        onBlur={this.handleChange}
                    />
                </div>
                {this.props.isCard ? (
                    <hr className="bottom-border-2 mx-0" />
                ) : ''}
            </div>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: IOpenEndedProps): IOpenEndedProps => {
    if (!state) {
        return ownProps;
    }
    const newProps: IOpenEndedProps = Object.assign({}, ownProps, {
        surveyChoices: state.coursePage.surveyChoices
    });
    return newProps;
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return {
        dispatch
    };
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    return next.coursePage.surveyChoices === prev.coursePage.surveyChoices;
};

const COpenEnded = connect(mapStateToProps, dispatchProps, null, {
    areStatesEqual
})(OpenEnded);

export default COpenEnded;
